import { toast } from 'react-toastify';

export function operationFailed(operation, target) {
    toast.error(`${operation}${target}失败`, { autoClose: 3000 });
}

export function operationSucceeded(operation, target) {
    toast.success(`${operation}${target}成功`, { autoClose: 3000 });
}

export function createFailed(target) {
    operationFailed('创建', target);
}

export function createSucceeded(target) {
    operationSucceeded('创建', target);
}

export function updateFailed(target) {
    operationFailed('修改', target);
}

export function updateSucceeded(target) {
    operationSucceeded('修改', target);
}

export function removeFailed(target) {
    operationFailed('删除', target);
}

export function removeSucceeded(target) {
    operationSucceeded('删除', target);
}

export function resetFailed(target) {
    operationFailed('重置', target);
}

export function resetSucceeded(target) {
    operationSucceeded('重置', target);
}
